import React from 'react';
import * as S from './ProfileInfo.styles';
import { BaseAvatar } from '@app/components/common/BaseAvatar/BaseAvatar';
import { LoginUserModel } from '@app/domain/LoginUserModel';

interface ProfileInfoProps {
  profileData: LoginUserModel | null;
}

export const ProfileInfo: React.FC<ProfileInfoProps> = ({ profileData }) => {
  // const [fullness] = useState(100);

  // const { t } = useTranslation();

  return profileData ? (
    <S.Wrapper>
      <S.ImgWrapper>
        <BaseAvatar shape="circle" src={'https://api.dicebear.com/8.x/thumbs/svg?seed=Kitty'} alt="Profile" />
      </S.ImgWrapper>
      <S.Title>{`${profileData?.FirstName} ${profileData?.LastName}`}</S.Title>
      <S.Subtitle>{'@' + profileData?.UserName}</S.Subtitle>
      {/* <S.FullnessWrapper>
        <S.FullnessLine width={fullness}>{fullness}%</S.FullnessLine>
      </S.FullnessWrapper>
      <S.Text>{t('profile.fullness')}</S.Text> */}
    </S.Wrapper>
  ) : null;
};
export default ProfileInfo;
